import React from 'react';
import type { BrowseCategory } from '@engage/browse-categories';
import { useBrowseCategoriesData } from './useBrowseCategoriesData';

const CATEGORY_SLUG_ORDER = {
  strength: 0,
  yoga: 1,
  stretching: 2,
  cycling: 3,
  cardio: 4,
  meditation: 5,
  walking: 6,
  running: 7,
  outdoor: 8,
  bike_bootcamp: 9,
  bootcamp: 10,
};

export const useGetCategoriesData = () => {
  const { data: categories } = useBrowseCategoriesData();

  return React.useMemo(() => {
    if (!categories?.browseCategories) return null;
    return (categories.browseCategories as BrowseCategory[]).sort(
      (cat1, cat2) => CATEGORY_SLUG_ORDER[cat1.slug] - CATEGORY_SLUG_ORDER[cat2.slug],
    );
  }, [categories]);
};
